var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.858,
    height: 18.858,
    viewBox: "0 0 18.858 18.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#828282;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.358,22.5v3.746a1.873,1.873,0,0,1-1.873,1.873H6.373A1.873,1.873,0,0,1,4.5,26.246V22.5",
    transform: "translate(-4.5 -11.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,15l4.683,4.683L19.866,15",
    transform: "translate(-6.754 -8.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,15.739V4.5",
    transform: "translate(-9.571 -4.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.366d48e86f5b55f9896a1821d1ccd9f8.svg";
export { ForwardRef as ReactComponent };